import { createFileRoute } from "@tanstack/react-router";
import AdminPartsMessages from "@/pages/admin/AdminPartsMessages";

export const Route = createFileRoute("/_adminLayout/admin/parts/messages/")({
  component: AdminPartsMessages,
});